import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('peopleResearcher', app)
  return store
}
